module.exports = __webpack_public_path__ + "img/checked_off.0a96dca0.svg";